// extracted by mini-css-extract-plugin
export default {"bar":"bar__T4+96","progress":"progress__iQBD9","holo":"holo__BqkIo","basic":"basic__jprHp"};